import { ApplicantInformationView } from "./view";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  breadcrumb,
  MenuItem,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import {navigateBack, navigateNext, stepProgress} from "../../../dataBase/stepProgress";
import {STEP_APPLICANTINFORMATION} from "../../../const/catalog";
import { useTranslation } from "react-i18next";
import { Steps } from "../../../enum/steps";
import LocalStorageService from "../../../services/localStorage";

const storageKey = "afy-steps";
const localStorageService = new LocalStorageService(storageKey);
const STEP = STEP_APPLICANTINFORMATION;

export const ApplicantInformation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [steps, setSteps] = React.useState<MenuItem[]>([]);
  const [breadCrumbs, setBreadCrumbs] = React.useState<breadcrumb[]>([]);

  useEffect(() => {
    setBreadCrumbs(stepProgress(STEP, true));
    setSteps(stepProgress(STEP));
  }, []);

  const onClickSaveForm = (data: any) => {
    console.log("Data", data);
    localStorageService.setStepStored({
      id: "",
      name: "ApplicantIformation",
      step: Steps.applicantInformation,
      completed: true,
      applicantInformation: data,
    });
  };

  const onNextStep = () => {
    navigateNext(STEP, navigate);
  };

  const onBackStep = () => {
    navigateBack(STEP, navigate);
  };

  return (
    <ApplicantInformationView
      breadCrumbs={breadCrumbs}
      steps={steps}
      t={t}
      onClickSaveForm={onClickSaveForm}
      onNextStep={onNextStep}
      onBackStep={onBackStep}
    />
  );
};
